import Component from 'ShopUi/models/component';
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { EDialogEvents } from 'PyzShopUi/scripts/modules/events/dialogEvent';
import EventBus from 'PyzShopUi/scripts/utils/eventBus';
import IEventBusSubscription from 'PyzShopUi/scripts/interfaces/Utils/IEventBusSubscription';
import Utils from 'PyzShopUi/scripts/utils/utils';
import GarmentSizeContainer from './garment-size-container';
import i18next from 'i18next';

export default class GarmentSizeDialog extends Component {

    private static readonly SELECTORS = {
        DATA_SELECT_PLACEHOLDER: '[data-select-placeholder]',
        GARMENT_SIZE_COLLECTION_IDENTIFIER: 'tiens-unique-garment-size-collection-identifier',
    };

    private eventBus: EventBus;
    private dialogTriggerElement: HTMLElement;
    private garmentSizeContentElement: HTMLElement;
    private targetId: string;
    private openDialogSubscription: IEventBusSubscription;

    protected readyCallback(): void {
    }

    protected init(): void {
        this.eventBus = EventBus.getInstance();
        this.dialogTriggerElement = this.querySelector('[data-target]');
        this.garmentSizeContentElement = this.querySelector('[data-garment-size-content-container]');
        this.targetId = this.dialogTriggerElement.dataset.target;

        // tslint:disable-next-line:no-any
        this.openDialogSubscription = this.eventBus.subscribe(EDialogEvents.OPEN_DIALOG, (target: any): void => {
            if (target !== undefined && target.id === this.targetId) {
                this.openDialogSubscription.unsubscribe();

                fetch(this.dataset.url)
                    // tslint:disable-next-line:no-any
                    .then((response: Response): Promise<any> => response.json())
                    .then(this.prepareResponseData)
                    .then(this.handleRequestResponse);
            }
        });
    }

    // tslint:disable-next-line:no-any
    private readonly prepareResponseData = (data: any): any => {
        data.dialogId = this.targetId;
        const tableSelectOptions = [];

        // tslint:disable-next-line:no-any
        data.garmentSizeCollection.forEach((table: any, loopIndex: number): void => {
            const collectionIdentifier = `${GarmentSizeDialog.SELECTORS.GARMENT_SIZE_COLLECTION_IDENTIFIER}-${loopIndex}`;
            // tslint:disable-next-line:no-any
            const availableCountries: any[] = [];

            const firstRow: object = Utils.getObjectEntries(table.sizes)[0];
            const firstRowKey: string = firstRow[0];
            const firstRowValues: string = firstRow[1];

            // tslint:disable-next-line:no-any
            Utils.getObjectEntries(data.garmentSizeCountries).forEach((country: [string, any]): void => {
                if (firstRowValues.hasOwnProperty(country[1])) {
                    availableCountries.push(country);
                }
            });

            table.firstSizeRowKey = firstRowKey;
            table.availableCountries = availableCountries;

            tableSelectOptions[loopIndex] = {
                value: collectionIdentifier,
                label: table.subtitle !== '' ? `${i18next.t(table.title, { ns: 'garment-size'})}: ${i18next.t(table.subtitle, { ns: 'garment-size'})}` : i18next.t(table.title, { ns: 'garment-size'}),
            };

            table.uniqueIdentifier = collectionIdentifier;
        });

        // tslint:disable-next-line:no-magic-numbers
        if (Object.keys(tableSelectOptions).length < 2) {
            return data;
        }

        data.tableSelectData = {
            floatingLabel: i18next.t('Order size', { ns: 'garment-size'}),
            options: tableSelectOptions,
        };

        return data;
    }

    // tslint:disable-next-line:no-any
    private readonly handleRequestResponse = (data: any): void => {
        this.renderDialog(data);

        this.eventBus.publish(EDialogEvents.OPEN_DIALOG, { id: this.targetId });
    }

    // tslint:disable-next-line:no-any
    private readonly renderDialog = (data: any): void => {
        createRoot(this.garmentSizeContentElement).render(
            <GarmentSizeContainer {...data} />
        );
    }
}
